<h2 mat-dialog-title>
	{{ 'txEmployeeDocuments.title' | translate }}
	<span *ngIf="data?.employeeName">- {{ data.employeeName }}</span>
</h2>

<mat-dialog-content>
	<div class="flex flex-column gap-3">
		<div *ngIf="loadingDocuments" class="text-sm text-gray-500">
			{{ 'txEmployeeDocuments.loading' | translate }}
		</div>

		<div *ngIf="!loadingDocuments && !hasEmployeeDocuments" class="text-sm text-gray-500">
			{{ 'txEmployeeDocuments.noDocuments' | translate }}
		</div>

		<div *ngIf="!loadingDocuments && hasEmployeeDocuments" class="w-full overflow-x-auto">
			<div class="table-scroll" style="--tscroll-min: 640px">
			<table mat-table [dataSource]="employeeDocuments" class="full-width">
				<ng-container matColumnDef="document_name">
					<th mat-header-cell *matHeaderCellDef class="font-weight-bold text-base">
						{{ 'txZeitKonto.documentName' | translate }}
					</th>
					<td mat-cell *matCellDef="let document">{{ document.document_name }}</td>
				</ng-container>

				<ng-container matColumnDef="document_description">
					<th mat-header-cell *matHeaderCellDef class="font-weight-bold text-base">
						{{ 'txZeitKonto.description' | translate }}
					</th>
					<td mat-cell *matCellDef="let document">{{ document.document_description }}</td>
				</ng-container>

				<ng-container matColumnDef="document_date">
					<th mat-header-cell *matHeaderCellDef class="font-weight-bold text-base">
						{{ 'txZeitKonto.documentDate' | translate }}
					</th>
					<td mat-cell *matCellDef="let document">{{ document.document_date | date: 'dd.MM.yyyy' }}</td>
				</ng-container>

				<ng-container matColumnDef="actions">
					<th mat-header-cell *matHeaderCellDef class="font-weight-bold text-base text-center">
						{{ 'txZeitKonto.actions' | translate }}
					</th>
					<td mat-cell *matCellDef="let document" class="text-center">
						<button
							mat-icon-button
							color="primary"
							[disabled]="document.loading"
							(click)="sendEmployeeDocument(document)"
							[matTooltip]="'txZeitKonto.downloadDocument' | translate">
							<fa-icon *ngIf="!document.loading" icon="download"></fa-icon>
							<fa-icon *ngIf="document.loading" icon="spinner" [spin]="true"></fa-icon>
						</button>
					</td>
				</ng-container>

				<tr mat-header-row *matHeaderRowDef="['document_name', 'document_description', 'document_date', 'actions']"></tr>
				<tr mat-row *matRowDef="let row; columns: ['document_name', 'document_description', 'document_date', 'actions'];"></tr>
			</table>
			</div>
		</div>
	</div>
</mat-dialog-content>

<mat-dialog-actions align="end">
	<button mat-button type="button" (click)="close()">
		{{ 'txEmployeeDocuments.close' | translate }}
	</button>
</mat-dialog-actions>
